import React, { Dispatch, SetStateAction } from 'react';
import { useParams } from 'react-router';
import EventListButtons from './create-buttons/event-list-button';
import EventListFilter from './create-buttons/event-list-filter';
interface Props {
  missedCount: number;
  plannedCount: number;
  completedCount: number;
  noticesCount: number;
  useCalendarView: boolean;
  setUseCalendarView: Dispatch<SetStateAction<boolean>>;
}

export default function Toolbar({
  missedCount,
  plannedCount,
  completedCount,
  noticesCount,
  useCalendarView,
  setUseCalendarView,
}: Props) {
  const { farmId } = useParams<{ farmId: string }>();

  return (
    <div>
      <EventListButtons
        farmId={farmId}
        useCalendarView={useCalendarView}
        setUseCalendarView={setUseCalendarView}
      />
      <EventListFilter
        missedCount={missedCount}
        plannedCount={plannedCount}
        completedCount={completedCount}
        noticesCount={noticesCount}
      />
    </div>
  );
}
